import React from 'react'
import {useState} from 'react';
import { Col, Form, Row } from 'react-bootstrap';


export default function Options(props) {
    
    const durationOptions = [
        {value: 5, text: '5'},
        {value: 10, text: '10'},
        {value: 15, text: '15'},
        {value: 20, text: '20'},
        {value: 25, text: '25'},
        {value: 30, text: '30'},
        {value: 35, text: '35'},
        {value: 40, text: '40'},
        {value: 45, text: '45'},
        {value: 50, text: '50'},
        {value: 55, text: '55'},
        {value: 60, text: '60'},
    ];

    const stageOptions = [
        {value: 1, text: '1'},
        {value: 2, text: '2'},
        {value: 3, text: '3'},
        {value: 4, text: '4'},
        {value: 5, text: '5'},
    ]
    
    const [selected, setSelected] = useState(durationOptions[4].value);
    const [stageSelected, setStageSelected] = useState(stageOptions[0].value)

   

    const handleChange = event => {
        console.log(event.target.value);
        setSelected(event.target.value);

        props.setStartingTime(event.target.value, stageSelected);

    }

    


    
    const handleChangeStages = event => {
        console.log(event.target.value)
        setStageSelected(event.target.value)
        props.setStartingTime(selected, event.target.value)
    }

  return (

    <div>
        <Row>
            
        <Col xs={10} sm={4} className="center-form">
          <Form.Label id="durationlabel" for="options" className="mb-3">Choose Duration (minutes)</Form.Label>
          <Form.Select id="duration" value={selected} onChange={handleChange}>
             {durationOptions.map(option => (
                  <option key={option.value} value={option.value}>
                      {option.text} mins
                  </option>
              ))}
          </Form.Select>
          <br></br>
          <Form.Label id="stagelabel" for="stages" className="mb-3">Stages</Form.Label>
          <Form.Select id="stage" value={stageSelected} onChange={handleChangeStages}>
              {stageOptions.map(option => (
                  <option key={option.value} value={option.value}>
                      {option.text}
                  </option>
              ))}
          </Form.Select>
          </Col>
          
          </Row>
    </div>
  )
}
